import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/a8.png";
import emotion from "../../Assets/Projects/a11.png";
import editor from "../../Assets/Projects/a10.png";
import chatify from "../../Assets/Projects/a12.png";
import suicide from "../../Assets/Projects/a9.png";
import bitsOfCode from "../../Assets/Projects/a13.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Nossos Principais <strong className="purple">Projetos </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Dona Julieta - Diaristas"
              description="Sistema completo desenvolvido para simplificar a gestão de empresas de serviços domésticos. A plataforma facilita todo o ciclo operacional, desde o cadastro e seleção de profissionais através da análise de currículos até o agendamento inteligente de serviços. Permite o gerenciamento centralizado de clientes, com histórico completo de atendimentos e sistema de avaliações. Automatiza a emissão de ordens de serviço, recibos e relatórios gerenciais, enquanto oferece controle financeiro integrado para pagamentos e comissões. Tudo em uma solução intuitiva que conecta diaristas qualificadas a clientes satisfeitos."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Design House"
              description="Criação de um site de design inovador, projetado para atrair e converter potenciais clientes. O site incorpora as tecnologias mais atuais e modernas, garantindo uma experiência de usuário fluida e envolvente. Inclui um portfólio interativo, showcases de projetos anteriores, e funcionalidades de contato dinâmico para facilitar a comunicação com clientes em potencial. A plataforma é otimizada para SEO e responsiva, assegurando visibilidade máxima em dispositivos móveis e desktops."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="G&N International Business"
              description="Desenvolvimento de uma plataforma de e-commerce robusta para a venda de produtos agrícolas, projetada para atender a um público global. O site oferece suporte em vários idiomas internacionais, garantindo acessibilidade para clientes de diferentes regiões. Inclui funcionalidades como catálogo de produtos detalhado, sistema seguro de pagamento, carrinho de compras intuitivo e integração com redes sociais para ampliar o alcance de mercado. A plataforma é otimizada para SEO e é responsiva, assegurando uma experiência de usuário consistente em todos os dispositivos."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="OrganizaAÍ"
              description="Projeto colaborativo desenvolvido para otimizar o processo da organização de eventos, facilitando o planejamento, a coordenação de atividades e o gerenciamento de participantes. A plataforma oferece ferramentas para criar agendas, enviar convites e conectar pessoas interessadas em eventos similares."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Framboesa Flix"
              description="Desenvolvimento de um site moderno e atraente que fornece informações completas sobre filmes, incluindo elenco, trailers e muito mais. Utilizando React.js, a plataforma oferece uma experiência de navegação fluida e interativa, com integração de APIs que garantem atualizações constantes sobre os lançamentos mais recentes e clássicos do cinema."
              ghLink="https://github.com/luizassano/REACT-Hamburgueria-Kenzie-luizassano"
              demoLink="https://framboesaflix.vercel.app"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
